import { render, staticRenderFns } from "./VideoGalleryFullscreen.vue?vue&type=template&id=2de16b8f&scoped=true&"
import script from "./VideoGalleryFullscreen.vue?vue&type=script&lang=js&"
export * from "./VideoGalleryFullscreen.vue?vue&type=script&lang=js&"
import style0 from "./VideoGalleryFullscreen.vue?vue&type=style&index=0&id=2de16b8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de16b8f",
  null
  
)

export default component.exports